module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-word-fill-9534e996.svg";